import { useTranslation } from 'react-i18next';
import { ControlledMultiPickerWithCategory } from 'src/shared/components/form/controlledMultiPickerWithCategory';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getCountys } from 'src/shared/services/countyService';

export const MemberAdvancedSearchCounty = () => {
  const { t } = useTranslation(['common']);
  const isMounted = useIsMounted();

  return (
    <ControlledMultiPickerWithCategory
      name='countyCode'
      limitTags={2}
      componentWidth='100%'
      callback={(x) => ConsoleHelper.log(x)}
      fetchMethod={async () => {
        try {
          const result = await getCountys(0, 500, 'lan', 'asc');
          if (isMounted()) {
            const countyArray: any = [];
            result.data.results.forEach((county) => {
              // Pushar in options för "Hela kategorin" som ska välja alla kompetenser inom samma kategori
              countyArray.push({
                code: county.code,
                parentName: county.name,
                parentCode: county.code,
                isParent: true,
                name: t('common:form.countyPickerAll', { region: county.name }),
              });
              if (county) {
                county.municipalities.forEach((muni) => {
                  // Pushar in alla kommuner
                  countyArray.push({
                    code: muni.code,
                    parentName: county.name,
                    parentCode: county.code,
                    isParent: false,
                    name: muni.name,
                  });
                });
              }
            });

            return countyArray;
          }
        } catch (e) {
          if (isMounted()) {
            ConsoleHelper.log(e);
          }
        }

        return [];
      }}
      label={t('common:form.countyAndMunicipality')}
    />
  );
};
